import React, { useState } from "react";
import PropTypes from "prop-types";
// import { Link } from 'react-router-dom';
import * as service from "etegrisService";

import {
	DefaultCell,
	// DateTimeCell,
	NumberCell,
	SelectColumnFilter,
	Table
} from "4-cards/Table";
import { useUserState } from "../employee/user-context";
import { useAccountsState } from "../AccountsProvider";
import { useAddressBookState } from "../AddressBookProvider";

// import Pencil from "svg/Pencil";

function CreatePdf({ row }) {
	const userState = useUserState();

	const accounts = useAccountsState();
	const addressBooks = useAddressBookState();

	const handleClick = async () => {
		await service.callCreateBpPdf(row.original);

		await service.createBpTransaction(
			row.original,
			userState.user,
			accounts,
			addressBooks
		);
	};

	return (
		<div className="h-full">
			<button>
				<div className="jde-button" onClick={handleClick}>
					Create
				</div>
			</button>
		</div>
	);
}

const columns = [
	{
		Header: "Row",
		accessor: (row, i) => i + 1,
		width: 50,
		Cell: DefaultCell
	},
	{
		Header: "",
		id: "create",
		width: 90,
		Cell: CreatePdf
	},
	{
		Header: "DOC #",
		accessor: "doc",
		// Filter: SelectColumnFilter,
		filter: "contains",
		Cell: DefaultCell
	},
	{
		Header: "Vendor AB#",
		accessor: "an8",
		Cell: DefaultCell
	},
	{
		Header: "Vendor Name",
		accessor: "name",
		Cell: DefaultCell
	},
	{
		Header: "Invoice",
		accessor: "invoice",
		width: 200,
		Cell: DefaultCell
	},
	{
		Header: "Voucher Batch",
		accessor: "icu",
		Filter: SelectColumnFilter,
		filter: "equals",
		Cell: DefaultCell
	},
	{
		Header: "Payment Batch",
		accessor: "paymentBatch",
		Filter: SelectColumnFilter,
		filter: "equals",
		Cell: DefaultCell
	},
	{
		Header: "Payment Number",
		accessor: "paymentNumber",
		Filter: SelectColumnFilter,
		filter: "equals",
		Cell: DefaultCell
	},
	// {
	// 	Header: "Invoice Date",
	// 	accessor: "tranh_date",
	// 	Cell: DateTimeCell,
	// 	width: 125
	// },
	{
		Header: "Amount",
		accessor: "amount",
		filter: "contains",
		width: 100,
		Cell: NumberCell
	},
	{
		Header: "Urrf",
		accessor: "urrf",
		sortable: false,
		Cell: DefaultCell
	}
	// {
	// 	Header: "Remark",
	// 	accessor: "remark",
	// 	sortable: false,
	// 	Cell: DefaultCell
	// }
];

export const VoucherTable = ({ vouchers }) => {
	const [filters, setFilters] = useState([]);
	const [globalFilter, setGlobalFilter] = useState("");

	function dispatchFiltersChanged(newFilters) {
		setFilters(newFilters);
	}

	function dispatchGlobalFilterChanged(newFilter) {
		setGlobalFilter(newFilter);
	}

	const hiddenColumns = [];

	return (
		<Table
			columns={columns}
			data={vouchers}
			hiddenColumns={hiddenColumns}
			showHiddenColumns={true}
			globalFilter={globalFilter}
			filters={filters}
			dispatchFiltersChanged={dispatchFiltersChanged}
			dispatchGlobalFilterChanged={dispatchGlobalFilterChanged}
		/>
	);
};

VoucherTable.propTypes = {
	vouchers: PropTypes.array.isRequired
};
